import categoryAnalyticsService from 'services/category-analytics-service'
import campaignService from '../../../services/campaigns-service'

const LOAD_CATEGORY_ANALYTICS_DETAILS = 'LOAD_CATEGORY_ANALYTICS_DETAILS'

export function loadCategoryAnalytics(filters) {
  return (dispatch, getState) => {
    return categoryAnalyticsService.getCategoryAnalyticsDetails(filters)
      .then((categoryAnalyticsDetails) => {
        dispatch({
          type: LOAD_CATEGORY_ANALYTICS_DETAILS,
          categoryAnalyticsDetails: categoryAnalyticsDetails
        })
      })
  }
}

// Reducer

export function categoryAnalyticsReducer(state = [], action) {
  switch (action.type) {
    case LOAD_CATEGORY_ANALYTICS_DETAILS : {
      return action.categoryAnalyticsDetails
    }
    default :
      return state
  }
}




// WEBPACK FOOTER //
// ./src/routes/CategoryAnalytics/modules/CategoryAnalytics.js